import {
    Card,
    CardContent,
    CardHeader,
    makeStyles,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Theme
} from '@material-ui/core';
import React from 'react';
import {GroupMember} from '../../../graphql/groups.datatypes';
import {EST, formatDateTime, formatMoney} from '../../../utils/formatters';
import useRouter from 'use-react-router';

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        marginTop: theme.spacing(3),
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    linkButton: {
        marginRight: theme.spacing(1),
    },
    paymentButton: {
        marginRight: theme.spacing(1),
        color: theme.palette.white,
        backgroundColor: theme.palette.success.main,
        '&:hover': {
            backgroundColor: theme.palette.success.dark
        }
    },
}));

export const GroupMemberPaymentsList = (props: { groupMember: GroupMember }) => {
    const classes = useStyles();
    const {groupMember} = props;
    const {history} = useRouter();

    return (
        <Card className={classes.container}>
            <CardHeader title="Group Member Applied Payments"/>
            <CardContent>
                <Table style={{width: '100%'}}>
                    <TableHead>
                        <TableRow>
                            <TableCell style={{width: 215}}>Timestamp</TableCell>
                            <TableCell style={{width: 100}}>Amount</TableCell>
                            <TableCell style={{width: 100}}>Billing Party Id</TableCell>
                            <TableCell style={{width: 100}}>Payment Id</TableCell>
                            <TableCell>Paying Member</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {groupMember.groupMemberPayments && groupMember.groupMemberPayments.map(payment => {
                            return payment && payment.payment && (
                                <TableRow
                                    hover
                                    key={payment.id}
                                    onClick={() => history.push('/billing_party/' + payment.payment!.billingPartyMember!.billing_party_id)}
                                >
                                    <TableCell>{formatDateTime(payment.payment!.timestamp)}</TableCell>
                                    <TableCell>{formatMoney(payment.amount!, true)}</TableCell>
                                    <TableCell>{payment.payment.billingPartyMember && payment.payment.billingPartyMember.billing_party_id}</TableCell>
                                    <TableCell>{payment.payment && payment.payment.id}</TableCell>
                                    <TableCell>{payment.payment.billingPartyMember && payment.payment.billingPartyMember.first_name + ' ' + payment.payment.billingPartyMember.last_name}</TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
            </CardContent>
        </Card>
    );
};

export default GroupMemberPaymentsList;
